import * as React from 'react';
import styled from 'styled-components';
import { Helpers } from '@origin-digital/style-guide';

import { ImageBannerProps } from './ImageBanner.types';

export const Image = styled.div<ImageBannerProps>`
  overflow: hidden;
  background-image: url("${({ imageSrc }: ImageBannerProps) => imageSrc}");
  background-repeat: no-repeat;
  background-size: 143%;
  min-height: 128px;
  background-position: 59% 52%;
  ${Helpers.media.SM`
    min-height: 177px;
  `};
  ${Helpers.media.MD`
    background-position: 0 46%;
    background-size: 100%;
  `};
  ${Helpers.media.LG`
    background-position: 0 53%;
  `};
  ${Helpers.media.XL`
    background-position: center 49%;
    min-height: 300px;
    background-size: auto;
  `};
}
`;

const ImageBanner: React.StatelessComponent<ImageBannerProps> = ({
  imageSrc
}: ImageBannerProps): JSX.Element => {
  return <Image imageSrc={imageSrc} />;
};

export { ImageBanner as default };
